module.exports = __webpack_public_path__ + "img/slides-1.528b9aec.png";